/**
 * The action `reset()` dispatches on logout, after redux-persist purges
 * storage. A slice that must not outlive the participant's session resets on
 * it. Kept apart from `store.ts`, with no imports, so a slice can handle it
 * without importing the store that combines it.
 */
export const RESET_STATE = "RESET_STATE";
